import {
	blackColor,
	blackColors,
	dangerColor,
	hexToRgb,
	whiteColor,
	primaryColor,
} from 'assets/jss/material-dashboard-pro-react';

const paymentFormStyle = (theme) => ({
	tokensContainer: {
		maxHeight: 172,
		overflowY: 'auto',
		paddingLeft: 21,
		marginBottom: 61,
	},
	cardsContainer: {
		paddingLeft: 50,
		paddingTop: 24,
	},
	paymentContainer: {
		maxWidth: 367,
		margin: '0 auto',
		padding: '60px 0 0',
		[theme.breakpoints.down('sm')]: {
			padding: '60px 20px 60px 30px',
		},
	},
	paymentMethodContainer: {
		padding: '28px 112px 82px 63px',
	},
	tokenCardLogo: {
		marginRight: 8,
		width: '28px',
	},
	tokenCard: {
		display: 'flex',
		alignItems: 'center',
	},
	cardContainer: {
		textAlign: 'center',
		display: 'inline-flex',
		flexDirection: 'column',
		alignSelf: 'center',
		marginTop: 54,
		marginBottom: 26,
	},
	cont: {
		display: 'flex',
		flexDirection: 'column',
	},
	cardData: {
		padding: '10px 31px 8px 25px',
		borderRadius: 8,
		border: `solid 2px ${primaryColor[0]}`,
		display: 'inline-flex',
		flexDirection: 'column',
		boxShadow: '0 8px 12px -6px rgba(0, 0, 0, 0.5)',
	},
	cardIcon: {
		width: 48,
		height: 48,
	},
	paymentCard: {
		marginBottom: 24,
	},
	billingAddress: {
		marginTop: 30,
	},
	noPadding: {
		paddingTop: 10,
	},
	cardBrand: {
		position: 'absolute',
		top: theme.direction === 'rtl' ? 18 : 26,
		left: -40,
		height: 32,
		width: 32,
		[theme.breakpoints.down('sm')]: {
			top: theme.direction === 'rtl' ? 23 : 31,
			left: -28,
			width: 24,
			height: 24,
		},
	},
	monthCvvContainer: {
		display: 'flex',
		position: 'relative',
		'& > div': {
			width: '100%',
		},
		'& > div:nth-child(odd)': {
			marginRight: 8,
		},
		'& > div:nth-child(even)': {
			marginLeft: 8,
		},
	},
	cvvInfo: {
		position: 'absolute',
		top: 70,
		right: -45,
		width: 380,
		zIndex: 5,
		padding: '40px 32px 23px',
		borderRadius: 2,
		backgroundColor: whiteColor,
		boxShadow: `0 7px 8px 0 rgba(${hexToRgb(blackColor)}, 0.18), 0 5px 22px 4px ${
			blackColors[5]
		}, 0 12px 17px 2px ${blackColors[5]}`,

		'&::after': {
			position: 'absolute',
			top: -12,
			right: 45,
			content: "' '",
			padding: 10,
			backgroundColor: whiteColor,
			zIndex: -1,
			transform: 'rotateY(0deg) rotate(45deg)',
		},
		[theme.breakpoints.only('sm')]: {
			right: -15,
			'&::after': {
				right: 15,
			},
		},
		[theme.breakpoints.only('xs')]: {
			width: 280,
			right: -15,
			paddingLeft: -16,
			paddingRight: -16,
			'&::after': {
				right: 16,
			},
		},
	},
	right: {
		textAlign: 'right',
	},
	close: {
		position: 'absolute',
		top: 13,
		right: 13,
		cursor: 'pointer',
		'& svg': {
			fontSize: '24px',
			color: blackColors[3],
		},
		'&:hover svg': {
			color: blackColors[2],
		},
	},
	center: {
		textAlign: 'center',
	},
	securityCode: {
		marginTop: 18,
		[theme.breakpoints.down('xs')]: {
			'& img': {
				width: 220,
			},
		},
	},
	help: {
		cursor: 'pointer',
	},
	limitWarning: {
		padding: '16px 24px',
		backgroundColor: `rgba(${hexToRgb(dangerColor[0])}, 0.06)`,
		borderRadius: 8,
		border: `1px solid ${dangerColor[0]}`,
		[theme.breakpoints.up('md')]: {
			position: 'relative',
			width: 'calc(100% + 2 * 15px + 2 * 24px)',
			left: 'calc(-15px - 24px)',
		},
	},
	paymentSummary: {
		display: 'flex',
		alignItems: 'flex-start',
		'& > div': {
			width: '100%',
		},
		'& > div:nth-child(even)': {
			textAlign: 'right',
		},
	},
	paymentSummaryCaption: {
		marginBottom: 2,
	},
	donationValueWrapper: {
		marginBottom: 6,
	},
});

export default paymentFormStyle;
